import React, { useContext } from "react";
import { observer } from "mobx-react";
import { ResultsMenuStoreContext } from "@state/context/results";
import { ResultsCategoryList } from "./categories-menu";

export default observer(function ResultsCategoriesMenu() {
	const store = useContext(ResultsMenuStoreContext);

	if (store.selectedSportId === null) {
		return null;
	}

	return (
		<nav className="nav--tertiary">
			<ul className="nav--tertiary__menu">
				<ResultsCategoryList />
			</ul>
		</nav>
	);
});
